import { useContext, useEffect, useRef } from 'react';
import { GoogleAnalyticsContext } from '../../GoogleAnalytics';
import { useStepper } from '../../Stepper';
import euFlag from '../assets/europe-flag.jpg';
import StepWrapper from './StepWrapper';

export function EuOriginPage() {
  const { stepForward, localData, setDataByKey, activeStepKey, unvisitStep, gotoStep } = useStepper();

  const handleChange = (e) => {
    setDataByKey('euPref', e.target.value);
  };

  const nextPage = () => {
    if (!localData.euPref) {
      return;
    }

    stepForward();
  };

  const previousPage = () => {
    unvisitStep('Preferential Origin');
    gotoStep('1. Direction');
  };

  const isInitialized = useRef(false);
  const ga = useContext(GoogleAnalyticsContext);

  useEffect(() => {
    if (ga.gaInitialized) {
      if (activeStepKey === 'eu_origin' && isInitialized.current === false) {
        isInitialized.current = true;
        window?.gtag?.('event', '1. EuOrigin', {
          event_category: 'EPO',
        });
      }
    }
  }, [activeStepKey, ga.gaInitialized]);
  return (
    <StepWrapper
      stepTitle="EU Preferential Origin"
      stepText={'EU Preferential Origin'}
      stepKey="eu_origin"
      handleNextClick={nextPage}
      handleBackClick={previousPage}
      hideUntilActive
      hideUnlessVisited
    >
      <div className="d-flex step-banner justify-content-center">
        <img
          className="d-flex"
          src={euFlag}
          width="200"
          height="130"
          alt=""
          style={{ borderRadius: '15px', marginTop: '34px', marginBottom: '34px' }}
        />
      </div>

      <div className="d-flex flex-column  align-self-center mt-auto" style={{ maxWidth: '390px' }}>
        <span className="d-flex align-self-center" style={{ fontWeight: '500' }}>
          Do all your invoice items have EU preferential origin?
        </span>
        <div className="d-flex align-self-center">
          <span style={{ fontWeight: '500' }}>
            Click{' '}
            <a href="https://www.eori.uk/origin" target="_blank" rel="noreferrer">
              HERE
            </a>{' '}
            for more information.
          </span>
        </div>
      </div>

      <label className="d-inline-flex justify-content-center mt-auto gap-3  ">
        <input
          type="radio"
          data-testid="euPrefYes-radio"
          name="euorigin"
          value="yes"
          checked={localData.euPref === 'yes'}
          onChange={handleChange}
        />
        <span>Yes</span>
      </label>

      <label className="d-inline-flex justify-content-center gap-3 mt-2">
        <input
          type="radio"
          data-testid="euPrefNo-radio"
          name="euorigin"
          value="no"
          checked={localData.euPref === 'no'}
          onChange={handleChange}
        />
        <span>No</span>
      </label>
    </StepWrapper>
  );
}
